export const MAX_AUDIO_SIZE_MILLISECONDS = 10000 // 10 sec
